<template>
  <div class="event-tip-popup">
    <div class="event-tip-popup-shade"></div>
    <div class="event-tip-popup-content">
      <p class="event-tip-popup-text">
        {{ letter.eventFriendCode }}<span class="code">{{ inviteCode }}</span>
      </p>
      <p class="event-tip-popup-text big">{{ letter.eventCheckBind }}</p>
      <div class="event-tip-popup-btn-wrap">
        <div class="btn cancel" @click="hidePopup">{{ letter.eventCancel }}</div>
        <div class="btn confirm" @click="sureBind">{{ letter.eventConfirm }}</div>
      </div>
      <a
        class="event-tip-popup-close j-click-tip-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>
  
  <script type="text/javascript">
export default {
  name: 'eventBindPopup',
  props: ['inviteCode'],
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closePopup');
    },
    sureBind() {
      this.$emit('sureBind');
    }
  },
  components: {}
};
</script>
  
  <style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';

.event-tip-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 52px;
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('event-bind-popup.png');
  }

  &-text {
    font-size: 32px;
    color: var(--event-popup-bind-text);
    text-align: left;
    width: 100%;
    &.big {
      font-size: 36px;
      margin-top: 10px;
    }
    .code {
      margin-left: 10px;
      color: var(--event-popup-bind-code-text);
    }
  }

  &-btn-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    align-self: center;
    width: 100%;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: cover;
      font-size: 36px;
      color: var(--global-tip-popup-btn);
      &.cancel {
        cursor: pointer;
        @psetbg ('cancel.png');
      }
      &.confirm {
        cursor: pointer;
        @psetbg ('confirm.png');
      }
    }
  }

  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
@media screen and (orientation: landscape) {
  .event-tip-popup {
    &-close {
      position: absolute;
      @psetbg ('close-hen.png');
    }
    &-btn-wrap {
      width: 70%;
      .btn {
        display: block;
        background-size: cover;
        line-height: 53px;
        font-size: 24px;
        &.cancel {
          cursor: pointer;
          @psetbg ('cancel-hen.png');
        }
        &.confirm {
          cursor: pointer;
          @psetbg ('confirm-hen.png');
        }
      }
    }
  }
}
</style>
  